import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import { LanguageProvider } from './context/LanguageContext';
import Navigation from './components/Navigation';
import Hero from './components/Hero';
import Mission from './components/Mission';
import Clients from './components/Clients';
import OfferCards from './components/OfferCards';
import OfferPage from './components/OfferPage';
import Contact from './components/Contact';
import About from './components/About';
import Footer from './components/Footer';
import Privacy from './components/Privacy';
import Terms from './components/Terms';
import SeoHead from './components/SeoHead';
import ScrollToTop from './components/ScrollToTop';
import './App.css';
import './styles/sections.css';

const HomeContent: React.FC = () => {
  return (
    <div className="App">
      <Navigation />
      <main>
        <Hero />
        <Mission />
        <OfferCards />
        <Clients />
        <Contact />
        <About />
      </main>
      <Footer />
    </div>
  );
};

const OfferPageLayout: React.FC = () => {
  return (
    <div className="App">
      <Navigation />
      <main className="offer-page-main">
        <OfferPage />
        <Contact />
      </main>
      <Footer />
    </div>
  );
};

const App: React.FC = () => {
  return (
    <Router>
      <ScrollToTop />
      <LanguageProvider>
        <HelmetProvider>
          <SeoHead />
          <Routes>
            <Route path="/offers/:offerId" element={<OfferPageLayout />} />
            <Route path="/en/offers/:offerId" element={<OfferPageLayout />} />
            <Route path="/es/offers/:offerId" element={<OfferPageLayout />} />
            <Route path="/privacy" element={<Privacy />} />
            <Route path="/terms" element={<Terms />} />
            <Route path="/en/privacy" element={<Privacy />} />
            <Route path="/en/terms" element={<Terms />} />
            <Route path="/es/privacy" element={<Privacy />} />
            <Route path="/es/terms" element={<Terms />} />
            <Route path="/en" element={<HomeContent />} />
            <Route path="/es" element={<HomeContent />} />
            <Route path="/" element={<HomeContent />} />
          </Routes>
        </HelmetProvider>
      </LanguageProvider>
    </Router>
  );
};

export default App;
